import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { MdSupportAgent } from 'react-icons/md';
import { useUiComponentsInternationalContext } from '@repo/static-translations';

import sharedStyles from '../styles';

const StyledContainer = styled.li`
  margin: ${sharedStyles.spacing['spacing-md']} 0;
  display: flex;
  gap: ${sharedStyles.spacing['spacing-1xs']};
`;

const IconContainer = styled.div`
  color: ${({ theme }) => theme.colors.brandPrimary};
  width: 1.15rem;
  height: 1.15rem;
`;

const TextColumn = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  line-height: 1.15;
  p {
    margin: 0;
  }
`;

function CustomerCareMessaging({ isUSLocale }) {
  const { tt } = useUiComponentsInternationalContext();

  return (
    <StyledContainer>
      <IconContainer>
        <MdSupportAgent size={19} />
      </IconContainer>
      <TextColumn>
        {isUSLocale ? (
          <p>
            {tt(s => s.productCommon.customerCareMessageForUS, {
              entity: <b>{tt(s => s.productCommon.usBasedCustomerCare)}</b>,
            })}
          </p>
        ) : (
          <p>
            {tt(s => s.productCommon.customerCareMessageForLocal, {
              entity: <b>{tt(s => s.productCommon.localDealerNetwork)}</b>,
            })}
          </p>
        )}
      </TextColumn>
    </StyledContainer>
  );
}

CustomerCareMessaging.propTypes = {
  isUSLocale: PropTypes.bool.isRequired,
};

export default CustomerCareMessaging;
